import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ScheduleLesson } from '../../../interfaces/schedule';

@Component({
  selector: 'app-schedule-slot',
  templateUrl: './schedule-slot.component.html',
  styleUrls: ['./schedule-slot.component.scss', './schedule-slot.component.en.scss']
})
export class ScheduleSlotComponent implements OnInit {
  @Input() onlineClassText!: any;
  @Input() cancelledClassText!: any;
  @Input() hibridClassText!: any;
  @Input() lessons!: ScheduleLesson[];
  @Input() homeMode: boolean = false;
  @Input() range!: number[];
  @Input() notificationsHeaderText: string = "";
  @HostBinding('style.--slot-position') @Input() startPosition: number = 0;

  ngOnInit() {
    let startTime = this.range[0];
    let spaceBefore = 0;

    this.lessons = this.lessons.map((lesson, i) => {
      spaceBefore = lesson.timeStart - startTime;
      startTime = lesson.timeEnd;

      return {...lesson, spaceBefore }
    });
  }
}
